import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-thank-you-page',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './thank-you-page.component.html',
  styleUrl: './thank-you-page.component.scss'
})
export class ThankYouPageComponent {

  constructor(private router: Router) {}

  goToHome() {
    this.router.navigate(['/landing']);
  }

}
